import { render } from "./LogoImage.vue?vue&type=template&id=0342e640&scoped=true"
import script from "./LogoImage.vue?vue&type=script&lang=js"
export * from "./LogoImage.vue?vue&type=script&lang=js"

import "./LogoImage.vue?vue&type=style&index=0&id=0342e640&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0342e640"]])

export default __exports__